import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom'

import Rollbar from './rollbar'
import Store from './store'
import Router from './router'

const localDataString = localStorage.getItem('booking_data')

if(localDataString) {
  window.__INITIAL_STATE__ = JSON.parse(localDataString)
}

const router = Router()
const store = Store(router, window.__INITIAL_STATE__)
const rootEl = document.querySelector('#root')

window.__saveState = () => {
  localStorage.setItem('booking_data', JSON.stringify(store.getState()))
}

window.__resetState = () => {
  localStorage.removeItem('booking_data')
}

let render = () => {
  const RootAppComponent = require('./root').default
  ReactDOM.render(
    <RootAppComponent
      store={ store }
      router={ router }
    />,
    rootEl
  )
}

if(module.hot) {
  module.hot.accept('./root', () => {
    setTimeout(render)
  })
}

render()
Rollbar()